// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/ScheduleOptions/Content/LocationSelect/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_Old_ScheduleOptions_Content_LocationSelect{
  session_user_locations(order_by: { name: asc }) {
    id
    _id
    name
    time_zone_id
  }
}

`